import { action } from 'typesafe-actions';

import { SystemMaintenanceDB, SystemMaintenanceTypes } from './types';

export const saveSystemMaintenanceStarted = (systemMaintenanceIds: number[], isDisabled: number) => action(SystemMaintenanceTypes.SAVE_SYSTEM_MAINTENANCE_STARTED, { systemMaintenanceIds, isDisabled });
export const saveSystemMaintenanceSuccessful = (option: SystemMaintenanceDB[]) => action(SystemMaintenanceTypes.SAVE_SYSTEM_MAINTENANCE_SUCCESSFUL, option);
export const saveSystemMaintenanceFailed = (error: string) => action(SystemMaintenanceTypes.SAVE_SYSTEM_MAINTENANCE_FAILED, error);

export const fetchSystemMaintenanceStarted = () => action(SystemMaintenanceTypes.FETCH_SYSTEM_MAINTENANCE_STARTED);
export const fetchSystemMaintenanceSuccessful = (option: SystemMaintenanceDB[]) => action(SystemMaintenanceTypes.FETCH_SYSTEM_MAINTENANCE_SUCCESSFUL, option);
export const fetchSystemMaintenanceFailed = (error: string) => action(SystemMaintenanceTypes.FETCH_SYSTEM_MAINTENANCE_FAILED, error);
